"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const RightsholderMaintenanceBankingTabHeader = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null, " The Banking and Tax tab needs to be fully completed before any royalties can be paid out."),
    react_1.default.createElement("p", null,
        react_1.default.createElement("strong", null, "*Please note:"),
        " To ensure the royalties for each distribution are routed correctly,",
        react_1.default.createElement("strong", null, " this page is temporarily disabled from the 3rd through the 14th of each month."),
        " This occurs on Central Standard Time (CST) at midnight.")));
exports.default = RightsholderMaintenanceBankingTabHeader;
